import {
  AuthAsActionTypes,
  SignAsTeacherPayload,
  SET_SELECTED_TEACHER,
  OPEN_SIGNIN_AS_TEACHER_MODAL,
  CLOSE_SIGNIN_AS_TEACHER_MODAL,
  GET_TEACHERS_START,
  SIGNIN_AS_TEACHER_START,
  LOGOUT_AS_START,
} from './types';

const authAsActions = {
  openSigninAsTeacherModal: (): AuthAsActionTypes => ({
    type: OPEN_SIGNIN_AS_TEACHER_MODAL,
  }),
  closeSigninAsTeacherModal: (): AuthAsActionTypes => ({
    type: CLOSE_SIGNIN_AS_TEACHER_MODAL,
  }),
  getTeachers: (value: string): AuthAsActionTypes => ({
    type: GET_TEACHERS_START,
    payload: { value },
  }),
  setSelectedTeacher: (payload: SignAsTeacherPayload): AuthAsActionTypes => ({
    type: SET_SELECTED_TEACHER,
    payload,
  }),
  signinAsTeacher: (): AuthAsActionTypes => ({
    type: SIGNIN_AS_TEACHER_START,
  }),
  logoutToSuperteacher: (): AuthAsActionTypes => ({
    type: LOGOUT_AS_START,
  }),
};

export default authAsActions;
